import OptimizedImage from "hooks/OptimizedImage";
import React from "react";
import { Link } from "gatsby";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export default function MidSubText({ data }) {
  return (
    <>
      <div className="bg-[#000000] px-6 sm:px-10  py-4">
        {data?.service_links?.length > 0 && (
          <>
            <div className="text-white w-full sm:w-8/12 m-auto text-14 sm:text-new">
              {"Services"}
              <FontAwesomeIcon icon={faAngleRight} className="ml-3" />
              {data?.service_links.map(({ link, text }, index) => (
                <>
                  <Link className=" py-2  ml-2 text-lightBlue cursor-pointer" to={link}>
                    {text}
                  </Link>
                  {index !== data?.service_links.length - 1 && <FontAwesomeIcon icon={faAngleRight} className="ml-3" />}
                </>
              ))}
            </div>
          </>
        )}
        {data?.language_links?.length > 0 && (
          <>
            <div className="text-white w-full sm:w-8/12 m-auto text-14 sm:text-new">
              {"Languages"}
              <FontAwesomeIcon icon={faAngleRight} className="ml-3" />
              {data?.language_links.map(({ link, text }, index) => (
                <>
                  <Link className=" py-2 ml-2 text-lightBlue cursor-pointer" to={link}>
                    {text}
                  </Link>
                  {index !== data?.language_links?.length - 1 && <FontAwesomeIcon icon={faAngleRight} className="ml-3" />}
                </>
              ))}
            </div>
          </>
        )}
      </div>
      <div className="flex items-center justify-center  w-full recent-wrapper">
        <div className="flex justify-evenly max-w-screen-2xl w-full xl:w-10/12 flex-col md:flex-row">
          <div className="md:w-7/12 w-full  px-6 ">
            <h2 className=" mt-12 text-lightBlue font-opensans">{data.title_x || data.seo_h1 || data.seo_project_title}</h2>
            <h3 className=" mt-1 mb-3 text-blackNew-400 font-opensans">
              <i className="text-base">{moment(data.seo_project_create_date).format("MMMM DD, YYYY")}</i>
            </h3>
            <h3 className="mb-5 text-black font-medium font-opensans">
              <i className="text-lg">By Ofer Tirosh</i>
            </h3>
            {data.cover_image !== "" && <OptimizedImage src={data.cover_image} alt={data.alt_tag} className="w-full object-cover h-auto lg:h-[370px] " />}
            <div className="font-normal text-base tracking-normal font-opensans text-white mb-8 mt-8" dangerouslySetInnerHTML={{ __html: data.seo_project_content }} />
          </div>
          <div className="md:w-1/4 w-full md:mt-36 mt-11 sm:border-l sm:border-gray sm:pl-6 h-2/3">
            <p className="text-black sm:text-3xl mt-10  pb-8 font-primary font-bold text-center md:text-left" style={{ fontWeight: "700", color: "black", fontSize: "32px" }}>
              Why choose us
            </p>
            <div className="sm:w-9/12 text-center mb-7">
              <img src="https://tomedes.gumlet.io/frontend/images/why-us-img/24-7-human-support.svg" alt="" className="m-auto inline-block w-20" />
              <p className="text-lg font-primary text-white mt-4">24/7 Human Support</p>
            </div>
            <div className="sm:w-9/12 text-center mb-7">
              <img src="https://tomedes.gumlet.io/frontend/images/why-us-img/quality-guaranteed-color.svg" alt="" className="m-auto inline-block w-20" />
              <p className="text-lg font-primary text-white mt-4">1 Year Guarantee</p>
            </div>
            <div className="sm:w-9/12 text-center mb-7">
              <img src="https://tomedes.gumlet.io/frontend/images/why-us-img/50000-business.svg" alt="" className="m-auto inline-block w-20" />
              <p className="text-lg font-primary text-white mt-4">95,000 Business Customers</p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#000000] text-white w-full mx-auto font-primary font-light p-6 listed">
        <div className="py-3 w-9/12 mx-auto">
          <h3 className="text-lightBlue text-24 mb-5 font-primary">Related Case Studies</h3>
          <ul>
            {data?.recent_news.map(({ slug, label }, index) => (
              <li>
                <Link className="text-new py-2  hover:text-lightBlue cursor-pointer" to={slug}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div class="bg-[#000000] text-white w-full mx-auto font-primary font-light flex justify-center items-center  flex-wrap lg:flex-nowrap lg:flex-row flex-col">
        <div className="flex flex-col mx-20 py-5">
          <p style="color:#fff;font-size:21px;">Ready to get started?</p>
          <span class="random1 green-btn" style="border-radius: 40px;margin-top: 30px;background-color: rgb(127, 205, 23) !important;padding: 10px;text-align: center;">
            <Link hreflang="en-us" to="/quote" class="tomedes-button green-btn-hvr">
              Translate Now
            </Link>
          </span>
        </div>
        <div className="flex flex-col mx-20 py-5">
          <p style="color:#fff;font-size:21px;">Want to tell us more about your needs?</p>
          <span
            class="random black"
            style="background: none;border-radius: 40px;border: 1px solid rgb(255, 255, 255);display: block;width: 150px;text-align: center;margin: auto;margin-top: 30px;padding: 12px 10px;"
          >
            <Link hreflang="en-us" to="/contactus.php" class="tomedes-button">
              Contact Us
            </Link>
          </span>
        </div>
      </div>
    </>
  );
}
